import { useEffect } from 'react';

import { useBaseInput } from '../VBaseInput';
import type { DATEPICKER_MODE } from './constant';
import useVDatePickerContext from './hook';
import style from './style';
import type { VDatePickerProps } from './type';

const VDateRangePickerInput = ({
  disabled,
  fromDatePlaceholder,
  toDatePlaceholder,
  valid,
}: Pick<
  VDatePickerProps<DATEPICKER_MODE.SINGLE>,
  'disabled' | 'fromDatePlaceholder' | 'toDatePlaceholder' | 'valid'
>) => {
  const { size, status, setStatus } = useBaseInput();
  const { value, onChange } = useVDatePickerContext<DATEPICKER_MODE.RANGE>();

  useEffect(() => {
    setStatus(prev => ({ ...prev, disabled, valid }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, valid]);

  return (
    <>
      <input
        className={style.vDatePickerInput({ size })}
        disabled={status.disabled ?? false}
        placeholder={fromDatePlaceholder}
        readOnly={status.readOnly ?? false}
        value={value[0]}
        onChange={e => onChange([e.target.value, value[1]!])}
        onFocus={() => setStatus(status => ({ ...status, focused: true }))}
        onBlur={() => setStatus(status => ({ ...status, focused: false }))}
      />
      <span>~</span>
      <input
        className={style.vDatePickerInput({ size })}
        disabled={status.disabled ?? false}
        placeholder={toDatePlaceholder}
        readOnly={status.readOnly ?? false}
        value={value[1]}
        onChange={e => onChange([value[0]!, e.target.value])}
        onFocus={() => setStatus(status => ({ ...status, focused: true }))}
        onBlur={() => setStatus(status => ({ ...status, focused: false }))}
      />
    </>
  );
};

export default VDateRangePickerInput;
